// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
    min-height: 246px;
    width: 100%;
    overflow: hidden;
    font-size: 19px;
    padding: 46px 100px;
}

.social-media-icons {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 30px;
    justify-content: center;
}

.social-media-link {
    width: 82px;
    height: 82px;
    border-radius: 50%;
}

.social-media-link a {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    flex-direction: column;
}

.social-media-link a svg {
    height: 30px;
}

.links {
    display: flex;
    text-align: end;
    line-height: 8px;
    flex-direction: column;
    align-items: flex-end;
    margin-top: -160px;
}

.link {
    text-decoration: underline;
}

.company-details {
    margin: 36px auto 0 auto;
    width: 961px;
    text-align: center;
}

@media (max-width: 820px) and (orientation: portrait) {

    footer {
        font-size: 16px;
        text-align: center;
        padding: 25px;
        display: flex;
        flex-direction: column;
    }

    .social-media-icons {
        order: 1;
        gap: 18px;
    }

    .social-media-link {
        width: 38px;
        height: 38px;
        border-radius: 50%;
    }

    .social-media-link a svg {
        height: 13px;
    }

    .company-details {
        margin: 18px auto 0 auto;
        min-width: 326px;
        max-width: 75%;
        text-align: center;
        order: 4;
    }

    #copyright {
        font-size: 16px !important;
        order: 3;
        margin-top: 18px !important;
        margin-bottom: 0;
    }

    .links {
        align-items: center;
        margin: 0;
        margin-top: 25px;
        order: 2;
        text-align: center;
    }
}

@media (max-width: 1180px) and (orientation: landscape) {

    footer {
        font-size: 16px;
        text-align: center;
        padding: 25px;
        display: flex;
        flex-direction: column;
    }

    .social-media-icons {
        order: 1;
        gap: 18px;
    }

    .social-media-link {
        width: 38px;
        height: 38px;
        border-radius: 50%;
    }

    .social-media-link a svg {
        height: 13px;
    }

    .company-details {
        margin: 18px auto 0 auto;
        min-width: 326px;
        max-width: 75%;
        text-align: center;
        order: 4;
    }

    #copyright {
        font-size: 16px !important;
        order: 3;
        margin-top: 18px !important;
        margin-bottom: 0;
    }

    .links {
        align-items: center;
        margin: 0;
        margin-top: 25px;
        order: 2;
        text-align: center;
    }
}

@media(max-width: 419px) {
    #email-link {
        line-height: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/footer/footer.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI;QACI,eAAe;QACf,kBAAkB;QAClB,aAAa;QACb,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;QACR,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,SAAS;QACT,gBAAgB;QAChB,QAAQ;QACR,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;QACI,eAAe;QACf,kBAAkB;QAClB,aAAa;QACb,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;QACR,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,SAAS;QACT,gBAAgB;QAChB,QAAQ;QACR,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["footer {\r\n    min-height: 246px;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    font-size: 19px;\r\n    padding: 46px 100px;\r\n}\r\n\r\n.social-media-icons {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 30px;\r\n    justify-content: center;\r\n}\r\n\r\n.social-media-link {\r\n    width: 82px;\r\n    height: 82px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.social-media-link a {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.social-media-link a svg {\r\n    height: 30px;\r\n}\r\n\r\n.links {\r\n    display: flex;\r\n    text-align: end;\r\n    line-height: 8px;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    margin-top: -160px;\r\n}\r\n\r\n.link {\r\n    text-decoration: underline;\r\n}\r\n\r\n.company-details {\r\n    margin: 36px auto 0 auto;\r\n    width: 961px;\r\n    text-align: center;\r\n}\r\n\r\n@media (max-width: 820px) and (orientation: portrait) {\r\n\r\n    footer {\r\n        font-size: 16px;\r\n        text-align: center;\r\n        padding: 25px;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .social-media-icons {\r\n        order: 1;\r\n        gap: 18px;\r\n    }\r\n\r\n    .social-media-link {\r\n        width: 38px;\r\n        height: 38px;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .social-media-link a svg {\r\n        height: 13px;\r\n    }\r\n\r\n    .company-details {\r\n        margin: 18px auto 0 auto;\r\n        min-width: 326px;\r\n        max-width: 75%;\r\n        text-align: center;\r\n        order: 4;\r\n    }\r\n\r\n    #copyright {\r\n        font-size: 16px !important;\r\n        order: 3;\r\n        margin-top: 18px !important;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .links {\r\n        align-items: center;\r\n        margin: 0;\r\n        margin-top: 25px;\r\n        order: 2;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n@media (max-width: 1180px) and (orientation: landscape) {\r\n\r\n    footer {\r\n        font-size: 16px;\r\n        text-align: center;\r\n        padding: 25px;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .social-media-icons {\r\n        order: 1;\r\n        gap: 18px;\r\n    }\r\n\r\n    .social-media-link {\r\n        width: 38px;\r\n        height: 38px;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .social-media-link a svg {\r\n        height: 13px;\r\n    }\r\n\r\n    .company-details {\r\n        margin: 18px auto 0 auto;\r\n        min-width: 326px;\r\n        max-width: 75%;\r\n        text-align: center;\r\n        order: 4;\r\n    }\r\n\r\n    #copyright {\r\n        font-size: 16px !important;\r\n        order: 3;\r\n        margin-top: 18px !important;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .links {\r\n        align-items: center;\r\n        margin: 0;\r\n        margin-top: 25px;\r\n        order: 2;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n@media(max-width: 419px) {\r\n    #email-link {\r\n        line-height: 18px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
